/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
 import { infoDisplayStylesV2, InfoDisplayStylesV2 } from "@eisinc/App/SharedStyles/InfoDisplayStylesV2";
 import { OrderDetailsPageContext } from "@eisinc/Overrides/Pages/OrderDetailsPage";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";

const styles: InfoDisplayStylesV2 = infoDisplayStylesV2;

const OrderDetailsCustomerPo: FC = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.customerPO) {
        return null;
    }

    const isCreditCard = order.properties.isCreditCard && order.properties.isCreditCard === "true";

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsCustomerPo">
                {isCreditCard ? translate("Reference #") : translate("PO #")}:
            </Typography>
            <Typography {...styles.contentText} aria-labelledby="orderDetailsCustomerPo">
                {order.customerPO}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsCustomerPo,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
